module.exports = __webpack_public_path__ + "assets/img/24_985_big.79411cc9.jpg";